import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 2rem 1rem 3rem 1rem;
`;

export const TitleWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const PgContainer = styled.div`
	background-color: var(--background-1);
	.switchInputMargin {
		margin-bottom: 5rem;
	}
`;

export const UpgradeAccountPackage = styled.div`
	display: flex;
	flex-direction: column;
	background: var(--white);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	padding: 2rem;
	height: 100%;
	@media ${Breakpoints.desktop} {
		.priceResponsiveFontSize {
			font-size: var(--paragraph1-font-size);
			align-self: center;
		}
	}
	@media ${Breakpoints.mobile} {
		.priceResponsiveFontSize {
			font-size: var(--heading2-font-size);
			align-self: center;
		}
	}
`;

export const HeadingCss = css`
	text-align: center;
	margin: 0 auto;
	margin-top: 2rem;
`;

export const SubtitleCss = css`
	text-align: center;
	margin: 2rem 0;
`;

export const CardContainer = styled.div`
	position: relative;
	transition: all 0.3s ease-in-out;
	ul {
		padding: 0;
	}
	li {
		font-size: var(--paragraph3-font-size);
		list-style: none;
		padding-right: 0.5rem;
		margin-bottom: 1.7rem;
		span {
			margin-right: 0.5rem;
			body[dir='rtl'] & {
				margin-left: 0.5rem;
			}
		}
		color: var(--content-2);
	}
	li:last-of-type {
		margin-bottom: 0;
	}
	div.badge {
		width: 12rem;
		text-align: right;
		color: var(--blue);
		background: rgba(63, 126, 235, 0.0784314);
		border-radius: var(--small-border-radius);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	@media ${Breakpoints.desktop} {
		div.badge {
			width: 4rem;
		}
		.popularBadge {
			display: none;
		}
	}
	div.discountBadge {
		text-align: right;
		padding: 0.3rem;
		color: var(--yellow);
		background: var(--green-10);
		margin: 0 var(--margin-2);
		border-radius: var(--small-border-radius);
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.priceContainerPosition {
		position: absolute;
		bottom: 1rem;
		display: flex;
	}
`;

export const ButtonContainerFlex = styled.div`
	background-color: var(--white);
	border-bottom: 1px solid var(--border-color);
	padding: var(--padding-2) var(--padding-3);
	display: flex;
	z-index: 1;
	justify-content: right;
	body[dir='rtl'] & {
		justify-content: left;
	}
	position: sticky;
	top: 0;
	left: 0;
	right: 0;
	> div {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		width: 20%;
		border-right: 1px solid var(--border-color);
		@media ${Breakpoints.mobileLandscape} {
			padding: var(--padding-2);
			width: 25%;
		}
		@media ${Breakpoints.tablet} {
			padding: var(--padding-1);
			width: 25%;
		}
		button {
			width: 100%;
			cursor: pointer;
		}
	}
	> div:last-of-type {
		border-right: none;
	}
	.regularButtonView {
		width: 60%;
	}
	@media ${Breakpoints.mobileLandscape} {
		top: -0.6rem;
		justify-content: center;
		.mobileButtonView {
			width: 100%;
		}
		.priceMobileSize {
			font-size: var(--caption-font-size);
		}
	}
	@media ${Breakpoints.mobile} {
		padding: var(--padding-1);
	}
`;

export const TableContainer = styled.div`
	width: 95%;
	margin: 2rem auto 0 auto;
	display: block;
	@media ${Breakpoints.desktop} {
		width: 90%;
		.packages {
			> div {
				width: 25%;
			}
		}
	}
	@media ${Breakpoints.tablet} {
		width: 95%;
		.packages {
			> div {
				width: 50%;
			}
		}
	}
	@media ${Breakpoints.mobile} {
		width: 100%;
		.packages {
			> div {
				width: 100%;
			}
		}
	}
	.active {
		border: 1px solid var(--blue);
	}
`;

export const TableSection = styled.div`
	width: 100%;
	background: var(--white);
`;

export const Table = styled.table`
	table-layout: fixed;
	border-spacing: 0;
	width: 100%;
	.accordionDesign {
		margin-top: unset;
		padding: var(--padding-1);
		> div {
			border: none;
			border-bottom: 1px solid var(--border-color);
			> div {
				border: none;
			}
		}
	}
	thead th {
		font-weight: bold;
		font-size: 2rem;
		display: block;
		margin-bottom: 1.5rem;
		text-align: left;
		body[dir='rtl'] & {
			text-align: right;
		}
	}
	tbody .fullSizeTableRow td {
		padding: var(--padding-1);
		width: 20%;
		text-align: center;
		font-size: var(--paragraph3-font-size);
		@media ${Breakpoints.tablet} {
			width: 25%;
		}
	}
	tbody .fullSizeTableRow td:first-of-type {
		padding: var(--padding-1);
		width: 20%;
		text-align: left;
		font-size: var(--paragraph3-font-size);
		body[dir='rtl'] & {
			text-align: right;
		}
	}
	.mobileSizeTableHeader {
		display: block;
		text-align: center;
		text-decoration: underline;
		margin: 1rem 0;
	}
	.mobileSizeTableRow {
		display: flex;
		gap: 1rem;
		text-align: center;
		margin: 1rem 0;
		td {
			padding: 0 0.5rem;
			border-right: 1px solid var(--border-color);
			body[dir='rtl'] & {
				border-right: unset;
				border-left: 1px solid var(--border-color);
			}
		}
		td:last-of-type {
			border-right: none;
		}
		td:last-of-type {
			body[dir='rtl'] & {
				border-left: none;
			}
		}
	}
`;

export const QuestionSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--padding-3);
	margin: 5rem auto;
`;

export const InlineTypography = styled.div`
	display: flex;
	flex-wrap: wrap;
`;

export const Centered = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
`;

export const DiscountContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: auto;
	padding: 0.25rem;
	gap: 0.5rem;
	background-color: var(--alert-success-bg);
	border: 1px solid #a1d872;
	border-radius: var(--small-border-radius);
`;
